// src/components/Header.jsx
import React from "react";
import { FiPhone, FiVideo, FiCloud, FiUser } from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import "./Header.css";

const ADMIN_UID = "I41qVJFkMhUcs2j3Gl8ytQx6qx33";

export default function Header({
  selectedChat,
  onStartAudioCall,
  onStartVideoCall,
  roomUsers,
  currentUser,
}) {
  const { logout } = useAuth();

  const openVeMeet = () => {
    if (!selectedChat) return alert("Select a chat first");
    const room = selectedChat.uid || selectedChat.id || selectedChat.chatId || "";
    window.open(
      `https://meet.vemeet.online/?room=${encodeURIComponent(room)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const navigateAdmin = () => {
    if (!currentUser) return alert("Please login");
    window.location.href = "/admin";
  };

  return (
    <header className="main-header fixed-header">
      <div className="header-left">
        <img
          src={selectedChat?.photoURL || "https://i.pravatar.cc/150"}
          alt="avatar"
          className="header-avatar"
        />
        <div className="header-contact-name">{selectedChat?.name || "NUKKAD"}</div>
      </div>

      <div className="header-right">
        <button className="icon-btn" onClick={openVeMeet} title="Open VeMeet">
          <FiCloud />
        </button>

        <button
          className="icon-btn"
          onClick={() => onStartAudioCall?.(selectedChat)}
          title="Audio Call"
        >
          <FiPhone />
        </button>

        <button
          className="icon-btn"
          onClick={() => onStartVideoCall?.(selectedChat)}
          title="Video Call"
        >
          <FiVideo />
        </button>

        {currentUser?.uid === ADMIN_UID && (
          <button className="icon-btn" onClick={navigateAdmin} title="Admin Panel">
            <FiUser />
          </button>
        )}

        <button className="icon-btn" onClick={logout} title="Logout">
          🚪
        </button>
      </div>
    </header>
  );
}
